import React, { Component } from 'react'
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from 'react-google-maps'

import markerIcon from '../../assets/images/marker.svg'

import "./LocationMap.scss"

const MapWrap = withScriptjs(withGoogleMap(props =>
  <GoogleMap
    defaultZoom={13}
    defaultCenter={{
      lat: props.location.latitude,
      lng: props.location.longitude
    }}
    options={{
      mapTypeControl: true,
      fullscreenControl: false,
      rotateControl: false,
      clickableIcons: true,
      scrollwheel: false,
      streetViewControl: false,
    }}
  >
    <Marker
      position={{lat: props.location.latitude, lng: props.location.longitude}}
      icon={{ url: markerIcon, size: {width: 33, height: 44}, anchor: {x:17 , y: 22}, scaledSize: {width: 33, height: 44} }}
    />
  </GoogleMap>
))

class LocationMap extends Component {

  render() {

    return (
      <section className="location-map">
        <MapWrap
          location={this.props.googleMap}
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDv1zgaT70XEt4XA70I92Hm0e3rHFre9Qk&v=3.exp&libraries=geometry,drawing,places"
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div style={{ height: `100%` }} className={'location-map__container'} />}
          mapElement={<div style={{ height: `100%` }} className={'location-map__container__map'} />}
        />
      </section>
    );
  }
}

export default LocationMap
